import React, { useState, useContext, useEffect } from "react";
import "./Accordion.css";
import DropDownIcon from "../../Assets/Images/drop-down-icon.png";
import DropDownDarkIcon from "../../Assets/Images/drop-down-dark-icon.png";
import { DynamicContext } from "../../Context/DynamicContext";

const Accordion = ({
  title,
  children,
  count,
  countBackgroundColor,
  accordionHeaderStyle = {},
  titleColor = "",
  defaultOpen = false,
  isDisabled = false,
  accordionContentStyle,
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  const { isDarkMode } = useContext(DynamicContext);

  useEffect(() => {
    setIsOpen(defaultOpen);
  }, [defaultOpen]);

  const toggleAccordion = () => {
    if (isDisabled) return;
    setIsOpen((prev) => !prev);
  };

  return (
    <div className="accordion-item">
      <div
        className="accordion-header"
        style={{
          ...accordionHeaderStyle,
          pointerEvents: isDisabled ? "none" : "auto",
        }}
        onClick={toggleAccordion}
        role="button"
        aria-expanded={isOpen}
        aria-disabled={isDisabled}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <span
            className="accordion-title"
            style={{
              color: titleColor,
              opacity: isDisabled ? 0.5 : 1,
            }}
          >
            {title}
          </span>
          {count > 0 && (
            <span
              className="accordion-count"
              style={{ backgroundColor: countBackgroundColor }}
            >
              {count}
            </span>
          )}
        </div>
        <div className="accordion-inner-header-container">
          <span className={`accordion-icon ${isOpen ? "rotate" : ""}`}>
            {!isDisabled && (
              <img
                src={isDarkMode ? DropDownDarkIcon : DropDownIcon}
                alt="DropDownIcon"
                className="drop-down-icon"
              />
            )}
          </span>
        </div>
      </div>
      {isOpen &&
        <div
          className="accordion-content"
          style={accordionContentStyle}
        >
          {children}
        </div>
      }
    </div>
  );
};

export default Accordion;
